document.addEventListener('DOMContentLoaded', function () {
$(".announcement_slide").removeClass("hidden");
  $('.announcement_slider').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 5000,
        adaptiveHeight: true,
        arrows: false,
        prevArrow:"<button type='button' class='slick-prev slick-arrow'><span class='slick_prev_after slick_arrow_after'></span></button>",
        nextArrow:"<button type='button' class='slick-next slick-arrow'><span class='slick_next_after slick_arrow_after'></span></button>",
     });
  $(".as-featured-in-wrapper").removeClass("hidden");
  $('.as-featured-in-wrapper').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 5000,
        adaptiveHeight: false,
        arrows: false,
        prevArrow:"<button type='button' class='slick-prev slick-arrow'><span class='slick_prev_after slick_arrow_after'></span></button>",
        nextArrow:"<button type='button' class='slick-next slick-arrow'><span class='slick_next_after slick_arrow_after'></span></button>",
    responsive: [
    {
      breakpoint: 767,
      settings: {
        dots: true
      }
    }
  ]
     });
  $(".blogs_Slider").removeClass("hidden");
  $('.blogs_Slider').slick({
  arrows: true,
  infinite:false,
  slidesToShow: 3,
  prevArrow:"<button type='button' class='slick-prev slick-arrow'><span class='slick_prev_after slick_arrow_after'></span></button>",
  nextArrow:"<button type='button' class='slick-next slick-arrow'><span class='slick_next_after slick_arrow_after'></span></button>",
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2
      }
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 1,
        dots:true
      }
    }
  ]
});
	
  
  let sectionsIntervals = {};

  function initializeTimer(sectionId, endDateTime, timerexp) {
    const daysValue = document.querySelector(`#days_${sectionId}`);
    const hoursValue = document.querySelector(`#hours_${sectionId}`);
    const minutesValue = document.querySelector(`#minutes_${sectionId}`);
    const secondsValue = document.querySelector(`#seconds_${sectionId}`);

    sectionsIntervals[sectionId] = setInterval(function () {
      const dateTimeNow = new Date().getTime();

      let difference = endDateTime - dateTimeNow;
      if (difference < 0) {
        document.querySelector(`.countdown-timer__wrapper--${sectionId}`).style.display = 'none';
        clearInterval(sectionsIntervals[sectionId]);
        daysValue.innerHTML = '0';
        hoursValue.innerHTML = '00';
        minutesValue.innerHTML = '00';
        secondsValue.innerHTML = '00';
        document.getElementById(`timer-message_${sectionId}`).style.display = 'block';
        if (document.getElementById(`timer-message_${sectionId}`).parentElement.parentElement.hasAttribute('href')) {
        document.getElementById(`timer-message_${sectionId}`).parentElement.parentElement.removeAttribute("href");
        }
        if(timerexp == 'true'){
        document.querySelector(`.countdown-timer__section_${sectionId}`).classList.add('visually-hidden');
        }
        document.querySelector(`.countdown-timer__section_${sectionId} .countdown-timer`).classList.remove('visually-hidden');
       } else {
        document.querySelector(`.countdown-timer__section_${sectionId} .countdown-timer`).classList.remove('visually-hidden');
        document.getElementById(`timer-message_${sectionId}`).classList.remove('section_link');
        daysValue.innerHTML = Math.floor(difference / (1000 * 60 * 60 * 24));
        hoursValue.innerHTML = ('0' + Math.floor((difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))).slice(-2);
        minutesValue.innerHTML = ('0' + Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60))).slice(-2);
        secondsValue.innerHTML = ('0' + Math.floor((difference % (1000 * 60)) / 1000)).slice(-2);
      }
    }, 1000);
  }

  const sections = Array.from(document.querySelectorAll('.countdown-timer__section'));

  sections.forEach(function (section) {
    const sectionId = section.id;
    const textdate = section.querySelector(`.textdate_${sectionId}`).textContent.trim();
    const texttime = section.querySelector(`.texttime_${sectionId}`).textContent.trim();
    const am_lm = section.querySelector(`.ampm_${sectionId}`).textContent.trim();
    const timerexp = section.querySelector(`.hidetimer_${sectionId}`).textContent.trim();
    
    const [year, month, day] = textdate.split('-').map(val => parseInt(val));
    const [hours, minutes] = texttime.split(':').map(val => parseInt(val));
    const isPM = am_lm === 'PM';
    let adjustedHours = hours;
    if (isPM && hours !== 12) {
      adjustedHours += 12;
    } else if (!isPM && hours === 12) {
      adjustedHours = 0;
    }
function isInSpecifiedRegion(timezone) {
    const specifiedRegions = [
        "America/New_York", // Eastern Time
        "America/Chicago", // Central Time
        "America/Denver", // Mountain Time
        "America/Los_Angeles", // Pacific Time
        "America/Toronto",
        "America/Vancouver"
        // Add more if needed
    ];
    return specifiedRegions.includes(timezone);
}

function convertToCST(year, month, day, adjustedHours, minutes) {
    const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const isCST = userTimeZone.includes("America");
    if (!isCST) {
        // Convert provided datetime to CST
      var localTime = new Date(year, month - 1, day, adjustedHours, minutes);
console.log(localTime,"localTime",localTime.getTimezoneOffset())
      var utcTime = new Date(localTime.getTime() + localTime.getTimezoneOffset() * 60000);
      var cstTime = new Date(utcTime.getTime() + (5.5 * 60 * 60 * 1000));
      var cstTimezone = cstTime.toLocaleString("en-US", {timeZone: "America/Chicago"});
      var cstTime = new Date(cstTime.toLocaleString("en-US", {timeZone: "America/Chicago"})).getTime();
      return cstTime; 
    } else {       
        return new Date(year, month - 1, day, adjustedHours, minutes).getTime();
    }
}
const endDateTime = convertToCST(year, month, day, adjustedHours, minutes);
    initializeTimer(sectionId, new Date(endDateTime).getTime(), timerexp);
  });
});


window.pageNumber = 2;
$('#custom_announcement_id details#Details-HeaderMenu-1').mouseover(function() {
  $('#custom_announcement_id details#Details-HeaderMenu-1').attr('open', true);
    $('#custom_announcement_id summary.header__menu-item.list-menu__item').attr('aria-expanded', 'true');
});
$('#custom_announcement_id details#Details-HeaderMenu-1').mouseout(function() {
  $('#custom_announcement_id details#Details-HeaderMenu-1').removeAttr('open');
    $('#custom_announcement_id summary.header__menu-item.list-menu__item').attr('aria-expanded', 'false');
});
// 

//add swatch image
$('.staticvariantimage option').each(function(){
  var varval = $(this).data('val');
  var varimg = $(this).data('img');
  $('.product-form__input').find('[value="' + varval + '"]').next().css('background-image', 'url(' + varimg + ')')
})

let interval = null

let domWorks = () => {
     let d = document.querySelector('.quick-add-modal__content-info')
     if(d){
       $(document).on('click','.quick-add__submit',function(){
        setTimeout(function() {
         // console.log("yes-in")
      $('.product__info-container .staticvariantimage option').each(function(){
    var varval = $(this).data('val');
    var varimg = $(this).data('img');
    $('.product__info-container .product-form__input').find('[value="' + varval + '"]').next().css('background-image', 'url(' + varimg + ')')
  })
        },5000);
       })
       
      clearInterval(interval) // Change it via reference
     }
}

interval = setInterval(domWorks, 100)


//change name on hover

// $('.product-form__input label').hover(function () {
//       $('.sel-val').text($(this).text());
// });
function attachEventListeners(selector) {
  document.querySelectorAll(selector).forEach(el => {
    el.addEventListener("mouseover", function() {
      const legendText = this.closest("fieldset").querySelector("legend .sel-val");
      if (legendText !== null) legendText.innerText = this.innerText;
    }, true);
  });
}
attachEventListeners('.product-form__input label');
attachEventListeners('#new-sticky-atc-variations .product-form__input label');

$(document).on('change', '.product-select', function(e){
  e.preventDefault();
  console.log();
  var id= $(this).children("option:selected").val();
  var price = $(this).children("option:selected").data('price');
  var variantImage = $(this).children("option:selected").data('variant-image');
  var availability = $('.product-select').children("option:selected").data('check');
  var variantTitle =  $(this).children("option:selected").data('variant-title');
  var prodId =  $(this).children("option:selected").data('product-id');
  
  $('.cart-drawer__upsell-atcs').attr('data-id',id);
  $('.cart-drawer__upsell-actions .body-4').html("+"+ price +"");
  if(variantImage){
    $('.cart-drawer-variant-image--' + prodId).html(`<img src="${variantImage}" alt="${variantTitle}" class="motion-reduce">`);
  }
  
  if(availability == 'soldout'){
    $('.cart-drawer__upsell-atcs').addClass('soldout');
  }
  else{
    $('.cart-drawer__upsell-atcs').removeClass('soldout');
  }
});

// $(document).on('click','.cart-drawer__upsell-atcs',function(e){
//   e.preventDefault();
 
//   var id = $(this).data('id');
//   console.log("id",id)
//   var obj = {
//     id: id,
//     quantity: 1
//   }
//     $.ajax({
//     url: '/cart/add.js',
//     type: 'POST',
//     data: obj,
//     dataType: 'json',
//     success: function(data){
//       console.log("data",data);
//        fetch('/cart?view=view').then(function(response) {
//         return response.text();
//       }).then(function(html) {
//         // Convert the HTML string into a document object
       
//         var parser = new DOMParser();
//         var doc = parser.parseFromString(html, 'text/html');
//         var div = doc.querySelector('tbody');
//         $('.cart-items tbody').html(div);
//         $('.drawer__close').trigger('click');
         
//          getCart();
         
//       });
//     },
//     error: function(err){
    
//     }
//     })
//   })

    function getCart(){
      $.ajax({
      url: '/cart.js',
      type: 'GET',
      dataType: 'json',
      success: function(cart){
      console.log('cart',cart);
        $('.cart-count-bubble span').html(cart.item_count);
      },
      error: function(err){
      console.log('error',err);
      }
      })
    }
    

// mega menu

// 

$('.mega-menu-wrapper .col-md-10.child-3 .row.col-4.coll-wrapper:first-child').addClass('active');
$('.mega-menu-wrapper .col-md-2.child-2 .list-wrapper a').click( function() {
$('.mega-menu-wrapper .col-md-10.child-3 .row.col-4.coll-wrapper:first-child').removeClass('active');
	var tabID = $(this).attr('data-sub');
    $(this).addClass('active').siblings().removeClass('active');
	$('div#tab-'+tabID).addClass('active').siblings().removeClass('active');	
});

$(document).ready(function() {
  // Initial activation for all sections
  $('.collection-tab').each(function() {
    $(this).find('.tabs li:first').addClass('active');
    $(this).find('.tab_content:first').addClass('active');
  });

  // Handle tab clicks for all sections
  $('.collection-tab .tabs li h2').click(function() {
    var tabID = $(this).attr('data-attr');
    var section = $(this).closest('.collection-tab'); // Get the closest collection-tab section

    // Activate tab and content within the current section
    $(this).parent().addClass('active').siblings().removeClass('active');
    $(section).find('div#' + tabID).addClass('active').siblings().removeClass('active');
  });
});


// Mobile Menu
   
$('details#Details-menu-drawer-container').click(function(){
  $('body').toggleClass('overflow')
});

$('.multicolumn_slider').slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        infinite: true,
        dots: false,
        autoplay: true,
        autoplaySpeed: 2000,
        prevArrow:"<button type='button' class='slick-prev slick-arrow'><span class='slick_prev_after slick_arrow_after'></span></button>",
        nextArrow:"<button type='button' class='slick-next slick-arrow'><span class='slick_next_after slick_arrow_after'></span></button>",
        responsive: [
          {
            breakpoint: 990,
            settings: {
              slidesToShow: 3
            },
          },
          {
            breakpoint: 767,
            settings: {
              slidesToShow: 2
            },
          },
          {
            breakpoint: 575,
            settings: {
              slidesToShow: 1
            },
          },
        ],
      });
      
  
  $('.testimonial-slider').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        dots: true,
        autoplay: true,
        autoplaySpeed: 3500,
        arrow: false
     });

  $('.empist-testimonials-slider').slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        dots: true,
        autoplay: true,
        autoplaySpeed: 2000,
        arrow: false,
        adaptiveHeight: true,
        responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2,
          }
        },
        {
          breakpoint: 576,
          settings: {
            slidesToShow: 1,
          }
        }
      ]
     });

  $(function() {
  	$('.empist-testimonials-slider .testimonial-height').matchHeight({property: 'height'});
  });

// product page accordian js

$(document).ready(function(){
  $(".tab_drawer_heading").on("click", function() {
    if ($(this).hasClass("d_active")){
      $(".tab_drawer_heading").removeClass("d_active");
      $(this).next().slideUp("fast"),
      $(this).removeClass("d_active"),
      $(this).next().removeClass("active_content");
    }
    else {
      $(".tab_drawer_heading").removeClass("d_active");
      $(this).toggleClass("d_active"),
        $(this).siblings(".tab_drawer_heading").removeClass("d_active");
      var e = $(this).attr("rel");     
      $(".tab_content").slideUp("fast");
      $(this).next().slideDown("fast");
    }
  });

  
// custom-announcement-bar account 

  $('.account.cursor-pointer').click(function () {
    $(this).next().slideToggle(500);
    $('.accordion-content').not($(this).next()).slideUp(500);

  });

  // setTimeout(function (params) {
  //   document.querySelectorAll('[id^="Deferred-Poster-"]').forEach(element => {
  //     console.log(element.getAttribute("autoplay-video"));
  //     if(element.getAttribute("autoplay-video") == "true"){
  //       element.click();
  //     }
  //   })
  // }, 3000);
  
});


/*Featured Collection Swatch Image*/

window.FeaturedCollectionSwatchImage = function(documentParam){
  documentParam.querySelectorAll('.swatches-list .swatch-featured-collection').forEach((Element)=>{
    Element.addEventListener('click',function(){
     var url = window.location.href;
        if(url.includes('search'))
        {
            $(".product-form__dropdown-text" ).each(function( index ) {
                console.log($(this).children());
                $(this).removeAttr("selected");
            });
            
        }
      let _this = this,
     
      getVariantImageUrl = _this.getAttribute('data-variant-imageurl');
      changeFirstUrl = _this.closest('.card-wrapper').querySelector('.card__media img.first--image-swatch');
      changeSecondUrl = _this.closest('.card-wrapper').querySelector('.card__media img.second--image-swatch');
      
      changeFirstUrl.setAttribute('srcset',getVariantImageUrl);
      if(changeSecondUrl){
      changeSecondUrl.setAttribute('srcset',getVariantImageUrl);
      }    
      
      
      if(document.querySelector('.swatch-featured-collection.active-image')!=null){
        document.querySelector('.swatch-featured-collection.active-image').classList.remove('active-image');
      }
      
      if($(this).data("variant-id")){
        let variantId = $(this).data("variant-id");
        let customUpdatedUrl = "";
        $(this).closest("li").find("a[href*='/products/']").each(function(index,obj){
          customUpdatedUrl = $(obj).attr("href").split("?")[0] + "?variant=" + variantId;
          obj.href = customUpdatedUrl;
        })
        customUpdatedUrl != "" ? $(this).closest("li").find("modal-opener button").attr("data-product-url",customUpdatedUrl) : '';
        $(this).closest("li").find("input[name='id']").val(variantId);
        $("#product-select [value='" + variantId + "']").attr("selected", "selected");
        var datacheck  =  $("#product-select [value='" + variantId + "']").attr("data-check");
        if(datacheck != 'soldout'){
          $(this).parents(".card__content").find(".quick-add").find(".quick-add__submit.add_to_cart").removeAttr("disabled");
          $(this).parents(".card__content").find(".quick-add").find(".quick-add__submit.add_to_cart span").text("Add To Cart")
        }else{
          $(this).parents(".card__content").find(".quick-add").find(".quick-add__submit.add_to_cart").attr("disabled","disabled");
          $(this).parents(".card__content").find(".quick-add").find(".quick-add__submit.add_to_cart span").text("Sold out")
        }
      }
      this.classList.add('active-image');
    });
  });
}

// call function to addevent.
window.FeaturedCollectionSwatchImage(document);

const checkDiv = setInterval(() => {
  if($('product-recommendations.product-recommendations.product-recommendations--loaded').length > 0) {
    clearInterval(checkDiv);
    window.FeaturedCollectionSwatchImage(document.querySelector("product-recommendations.product-recommendations.product-recommendations--loaded"));
  } 
}, 1000); // check after 100ms every time

var sel_menu = $('.child-3 .col-md-2 a.active').parents('.col-4').attr('data-id');
if(sel_menu){
  $('.child-2 .list-wrapper a').removeClass('active');
  $('.child-2 .list-wrapper').find('[data-sub="' + sel_menu + '"]').addClass('active');
  $('.child-2 .list-wrapper').find('[data-sub="' + sel_menu + '"]').trigger('click');
}


const checkComplementryProducts = setInterval(() => {
  if(document.querySelectorAll("product-form.customized-products .btn-customized-product").length > 0) {
    clearInterval(checkComplementryProducts);
    var bundleIds = [];
    var bIds = [];
    var eventSelectors = {
      _productCardElements: document.querySelectorAll("product-form.customized-products .btn-customized-product"),
    }

    window.complementaryBundle = {
      _init: function() {
        this._eventBinder()
      },
      _eventBinder: function(){
        for(var i=0 ; i < eventSelectors._productCardElements.length ; i++){
          eventSelectors._productCardElements[i].addEventListener('click', this._eventHandler.bind(this), true );
        }
      },
      _eventHandler: function(event) {
        var currVariantId = event.currentTarget.parentNode.querySelector("select").value;
        console.log(currVariantId,"currVariantId")

        var items = [];        
       
          items.push({'id': currVariantId, 'quantity': 1});
      
        let formData = {
         'items': items
        };
        fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(formData)
        })
        .then(response => {
          return response.json();          
        })
        .then (response => {
//           var url = new URL(window.location.href);
// url.searchParams.append('viewcart', 'true');
// window.history.pushState({}, '', url);


          // window.location.replace("/cart");
          document.addEventListener('rebuy:cart.change', (event) => { 
  console.log('rebuy:cart.change event', event.detail); 
            $('.cart-count-bubble').trigger('click');
});
        })
        .catch((error) => {
          console.error('Error:', error);
        });      
      },

    }
    window.complementaryBundle._init();
  } 
}, 100); // check after 100ms every time

/* HomePage video - Start  */

document.querySelectorAll("#vidbutton").forEach(element => {
  var ppbutton = element;
  ppbutton.addEventListener("click", playPause);

  function playPause(event) {
    var myVideo = event.currentTarget.parentNode.querySelector("#myvid");

    var myimage = event.currentTarget.parentNode.querySelectorAll(".my_img");

    if (!myVideo.paused) {
      myVideo.pause();
      myimage.forEach(img => img.classList.remove("remove_overlay_img"));
      ppbutton.querySelector('svg.pause').classList.add('hidden');
      ppbutton.querySelector('svg.play').classList.remove('hidden');   
    } else {
      myVideo.play();
      myimage.forEach(img => img.classList.add("remove_overlay_img"));
      ppbutton.querySelector('svg.pause').classList.remove('hidden');
      ppbutton.querySelector('svg.play').classList.add('hidden');
    }
  }
});

/* HomePage video - End  */


// document.querySelectorAll('[id^="Deferred-Poster-"]').forEach(element => {

//     console.log(element.getAttribute("autoplay-video"));
//     if(element.getAttribute("autoplay-video") == "true"){
//         element.click();
//     }
    
// })

/* Filter Custom Development - Start  */

   function removeParamFromUrl(url, paramName) {
      const urlObj = new URL(url);
      const searchParams = new URLSearchParams(urlObj.search);
      searchParams.delete(paramName);
      urlObj.search = searchParams.toString();
      return urlObj.toString();
    }
  
/*    function callAjaxForNextPages(url){

      var dataToBeReturned = "";
      console.log(url);
      var x = new XMLHttpRequest();
      x.open('GET', url, false);
      x.setRequestHeader('Cache-Control', 'no-cache');
      x.onloadend = function() {

        console.log("In onreadystatechange");
        
        if(x.readyState === 4) {
          switch(x.status) {
            case 200:
                return x.responseText.trim();
                break;

            default:
                return '';
                break;
          }
        }
      }
      x.send();
      return(x.responseText.trim());
    }
    */
  
    var stringToHTML = function (str) {
    	var parser = new DOMParser();
    	var doc = parser.parseFromString(str, 'text/html');
    	// return doc.body;
      return doc.querySelectorAll("#product-grid li")
    };
    function liElementsToStringArray(liElements) {
      var liStrings = "";

      liElements.forEach(function(liElement) {
        liStrings += liElement.outerHTML;
      });

      return liStrings;
    }

    async function fetchHTML(url) {
      const response = await fetch(url);
      const html = await response.text();
      return html;
    }

    window.sortListByPrice = function(order) {
      if(location.href.includes("warehouse-sale-2023")){
        const productList = document.querySelector("#product-grid");
        const products = Array.from(productList.getElementsByTagName("li"));
      
        products.sort((a, b) => {
          const priceA = parseInt(a.getAttribute("li_sort_by"));
          const priceB = parseInt(b.getAttribute("li_sort_by"));
      
          if (order === "ascending") {
            return priceA - priceB;
          } else if (order === "descending") {
            return priceB - priceA;
          }
        });
      
        products.forEach(product => productList.appendChild(product));
      }
    };

  window.customFilterFunctions = async  function(){
    document.querySelector(".facets-container .full-page-loader").classList.add("loading");
    document.querySelector(".facets-container .full-page-loader").classList.remove("visually-hidden");
    document.querySelector(".facets-container .full-page-loader").innerHTML = ".";

    if(document.querySelectorAll("#ProductGridContainer .collection-loader").length > 0){
      document.querySelector("#ProductGridContainer .collection-loader").classList.add("loading");
      document.querySelector("#ProductGridContainer .collection-loader").classList.remove("visually-hidden");
      document.querySelector("#ProductGridContainer .collection-loader").innerHTML = ".";
    }
    
    var AllPageData = "";

    if(document.querySelectorAll("div.pagination-wrapper").length > 0){

      var AllPageData = "";
      var totalPages = parseInt(document.querySelector("div.pagination-wrapper").getAttribute("pagination-total-pages"));
      var currentPage = parseInt(document.querySelector("div.pagination-wrapper").getAttribute("pagination-current-page"));
      newUrl = removeParamFromUrl(window.location.href, "page");
  
      /* for(let i = 1 ; i <= totalPages ; i++ ){
        if(i == currentPage){
          continue; console.log("Skipped!!"); 
        }
        var paginatedUrl = newUrl; 
        if(paginatedUrl.includes("?")){
          paginatedUrl = paginatedUrl + "&page=" + i; 
        }
        else{
           paginatedUrl =  paginatedUrl + "?page=" + i;
        }
        const response = await fetch(paginatedUrl);
        // console.log(response);
        let responseData = response.text();
        
        AllPageData = AllPageData + responseData;
        
      } */

      for (let i = 1; i <= totalPages; i++) {
        if (i === currentPage) {
          // Skip the current page and log a message
          console.log("Skipped!!");
          continue;
        }
        var paginatedUrl = newUrl;
        if (paginatedUrl.includes("?")) {
          paginatedUrl = paginatedUrl + "&page=" + i;
        } else {
          paginatedUrl = paginatedUrl + "?page=" + i;
        }
        try {
          const response = await fetch(paginatedUrl);
      
          if (response.ok) {
            const responseData = await response.text();
            AllPageData = AllPageData + responseData;
          } else {
            console.error('Network response was not ok.');
          }
        } catch (error) {
          console.error('Error:', error);
        }
      }

      var AllListItems = "";
  
      AllListItems = stringToHTML(AllPageData);
      AllListItems.forEach(el => {
        el.classList.add("otherPageContent");
        document.querySelector('#product-grid').append(el);
        // document.querySelector('#ProductGridContainerCount ul').append(el);
      });

    }

    setTimeout(function(){
      document.querySelectorAll("#product-grid li").forEach(el => {
        if(!window.variantIds.includes(el.getAttribute("collection-sibling-variant-id"))){
          window.variantIds = window.variantIds + " " + el.getAttribute("collection-sibling-variant-id");
        }
      });
  
      var varIds = window.variantIds.split(" ");
      for(let id in varIds){
        if( id != ''){
          if(document.querySelectorAll("#product-grid .variant-id-" + varIds[id]).length > 1){
            document.querySelectorAll("#product-grid .variant-id-" + varIds[id] ).forEach((element, index) => {
              if(index > 0){
                element.remove();
              }
            })
          }
        }   
      }
  
       // var arrCollSiblings = [];
      // document.querySelectorAll("#product-grid li.grid__item").forEach(el => {
      //     var collSiblings = el.getAttribute("collection-siblings").split("##@@comma@@##");
      //     arrCollSiblings[el.getAttribute("collection-sibling-variant-id")] = collSiblings;
      // });
      
      // var arrFilterVal = []
      // document.querySelectorAll("[collection_group]").forEach(ele => {
      //     var FilterVal = ele.getAttribute("collection_val");
      //     if(typeof FilterVal !== "undefined"){
      //         var count = 0;
      //         for(val in arrCollSiblings){
      //             if(arrCollSiblings[val].includes(FilterVal)){
      //                 count++;
      //                 for(val1 in arrCollSiblings[val]){                    
      //                     if(document.querySelector(`[data-filter-cm-${(arrCollSiblings[val][val1]).toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '')}]`)){
      //                         document.querySelector(`[data-filter-cm-${(arrCollSiblings[val][val1]).toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '')}]`).classList.add("data-filter-cm-do-not-remove");
      //                     }
      //                 }
      //             }
      //         }
      //         arrFilterVal[FilterVal] = count;
      //         if(count == 0){
      //             ele.classList.add("visually-hidden")
      //         }
      //         else{
      //             ele.classList.remove("visually-hidden")
      //         }
      //     }    
      // })
      
      // document.querySelectorAll("#product-grid li.grid__item").forEach(el => {
      //     if(!el.classList.contains("data-filter-cm-do-not-remove")){
      //         el.classList.add("visually-hidden");
      //     }
      // });
  
  
       // document.querySelectorAll(".active-facets").forEach(element => {
  
         // console.log("Hello I am Here!!", element.querySelectorAll("facet-remove[data-filter='out-of-stock']").length, element.querySelectorAll("facet-remove[data-filter='in-stock']").length);
         
        if(document.querySelector(`.active-facets facet-remove[data-filter='out-of-stock']`)){
          if(document.querySelectorAll(`[variant-available]`).length > 0){
            document.querySelectorAll(`[variant-available]`).forEach(el => {
              el.remove();
            })
          }
        }
        else if(document.querySelector(`.active-facets facet-remove[data-filter='in-stock']`)){
          if(document.querySelectorAll(`[variant-not-available]`).length > 0){
            document.querySelectorAll(`[variant-not-available]`).forEach(el => {
              el.remove();
            })
          }
        }
     // });
        
    
      document.querySelectorAll(".active-facets").forEach(element => {
        if(element.querySelectorAll("facet-remove[data-filter='out-of-stock']").length > 0 && element.querySelectorAll("facet-remove[data-filter='in-stock']").length > 0){
          document.querySelectorAll(`[in-stock]`).forEach(el => {
            el.innerHTML = document.querySelectorAll(`[variant-available]`).length;          
          })
          document.querySelectorAll(`[out-of-stock]`).forEach(el => {
            el.innerHTML = document.querySelectorAll(`[variant-not-available]`).length
          })
        }
        else if(element.querySelectorAll("facet-remove[data-filter='out-of-stock']").length > 0 || element.querySelectorAll("facet-remove[data-filter='in-stock']").length > 0){
         if(element.querySelectorAll("facet-remove[data-filter='out-of-stock']").length > 0){
            document.querySelectorAll(`[variant-available]`).forEach(ele => {
              ele.classList.add("visually-hidden");
            })
  
            document.querySelectorAll(`[in-stock]`).forEach(el => {
              el.innerHTML = 0       
            })
            document.querySelectorAll(`[out-of-stock]`).forEach(el => {
              el.innerHTML = document.querySelectorAll("li.grid__item").length - document.querySelectorAll("li.grid__item.visually-hidden").length
            })
           
           // document.querySelector(`[out-of-stock]`).innerHTML = document.querySelectorAll("li.grid__item").length - document.querySelectorAll("li.grid__item.visually-hidden").length;
           document.querySelector(`[in-stock]`).innerHTML = 0;
          }
          if(element.querySelectorAll("facet-remove[data-filter='in-stock']").length > 0){
            document.querySelectorAll(`[variant-not-available]`).forEach(ele => {
              ele.classList.add("visually-hidden");
            })
            
            document.querySelectorAll(`[in-stock]`).forEach(el => {
              el.innerHTML = document.querySelectorAll("li.grid__item").length - document.querySelectorAll("li.grid__item.visually-hidden").length;
            })
            document.querySelectorAll(`[out-of-stock]`).forEach(el => {
              el.innerHTML = 0;
            })
            // document.querySelector(`[in-stock]`).innerHTML = document.querySelectorAll("li.grid__item").length - document.querySelectorAll("li.grid__item.visually-hidden").length;
            // document.querySelector(`[out-of-stock]`).innerHTML = 0;
          }
        }
        else{
           document.querySelectorAll(`[in-stock]`).forEach(el => {
            el.innerHTML = document.querySelectorAll(`[variant-available]`).length;          
          })
          document.querySelectorAll(`[out-of-stock]`).forEach(el => {
            el.innerHTML = document.querySelectorAll(`[variant-not-available]`).length
          })
        }
      });
  
      var filterApplied = false;
      document.querySelectorAll(`[data-span-filter-collection-mf]`).forEach(el => {
        if(document.querySelectorAll(`[data-filter-collection-mf-` + el.getAttribute("data-filter-collection-mf") + `]`).length > 0){
  
          if(el.closest("li").querySelector("input").checked){
            document.querySelectorAll(`[data-filter-collection-mf-` + el.getAttribute("data-filter-collection-mf") + `]`).forEach(ele => {
              ele.classList.add("data-filter-collection-mf-count-me");
            });
            filterApplied = true;
          }
          
          var totalVarients = 0;
          
          totalVarients = (document.querySelectorAll(`[data-filter-collection-mf-` + el.getAttribute("data-filter-collection-mf") + `]`).length - document.querySelectorAll(`[data-filter-collection-mf-` + el.getAttribute("data-filter-collection-mf") + `].visually-hidden`).length);
          el.parentNode.querySelector(`span[` + el.getAttribute("data-filter-collection-mf") + `]`).innerHTML =  totalVarients < 0 ? 0 : totalVarients ;
          el.parentNode.querySelector(`span[` + el.getAttribute("data-filter-collection-mf") + `]`).closest("li").classList.remove("visually-hidden");
        }
        else{
            el.parentNode.querySelector(`span[` + el.getAttribute("data-filter-collection-mf") + `]`).innerHTML = 0;
            el.parentNode.querySelector(`span[` + el.getAttribute("data-filter-collection-mf") + `]`).closest("li").classList.add("visually-hidden");
        }
      });
  
      if(filterApplied){
        document.querySelectorAll("#product-grid li.grid__item").forEach(el => {
          if(!el.classList.contains("data-filter-collection-mf-count-me")){
            el.classList.add("visually-hidden");
            el.remove();
          }
        });
      }
  
  
      document.querySelectorAll("[data-span-filter-product-type]").forEach(el => {
        el.parentNode.querySelector("[" + el.getAttribute('data-filter-product-ype') + "]").innerHTML = document.querySelectorAll("[data-filter-product-type-" + el.getAttribute('data-filter-product-ype') + "]").length;
      });
    
      // document.querySelectorAll(`[data-span-filter-collection-mf]`).forEach(el => {
      //   if(document.querySelectorAll(`[data-filter-collection-mf-` + el.getAttribute("data-filter-collection-mf") + `]`).length > 0){
      //       var totalVarients = 0;
      //       totalVarients = (document.querySelectorAll(`[data-filter-collection-mf-` + el.getAttribute("data-filter-collection-mf") + `]`).length);
      //       el.parentNode.querySelector(`span[` + el.getAttribute("data-filter-collection-mf") + `]`).innerHTML =  totalVarients < 0 ? 0 : totalVarients ;
      //       el.parentNode.querySelector(`span[` + el.getAttribute("data-filter-collection-mf") + `]`).closest("li").classList.remove("visually-hidden");
      //   }
      //   else{
      //       el.parentNode.querySelector(`span[` + el.getAttribute("data-filter-collection-mf") + `]`).innerHTML = 0;
      //       el.parentNode.querySelector(`span[` + el.getAttribute("data-filter-collection-mf") + `]`).closest("li").classList.add("visually-hidden");
      //   }
      // });





      if(document.querySelector("#Filter-Price-LTE") && document.querySelector("#Filter-Price-GTE")){
        let maxPrice = parseFloat(document.querySelector("#Filter-Price-LTE").value);
        let minPrice = parseFloat(document.querySelector("#Filter-Price-GTE").value);
        let elValue = "";
        
        // If maxPrice is empty, set it to 100000
        if (isNaN(maxPrice) || maxPrice === '') {
          maxPrice = 100000;
        }
        
        // If minPrice is empty, set it to 0
        if (isNaN(minPrice) || minPrice === '') {
          minPrice = 0;
        }
        
        document.querySelectorAll("#product-grid li.grid__item").forEach(el => {
          elValue = (parseFloat(el.getAttribute("li_sort_by")) / 100);
        
          // Check if either maxPrice or minPrice condition is met
          if ((maxPrice === 100000 || elValue < maxPrice) && (minPrice === 0 || elValue > minPrice)) {
            // el.classList.remove("visually-hidden"); // Show the element
          } else {
            el.classList.add("visually-hidden"); // Hide the element
            el.remove(); // Remove the element from the DOM
          }
        });
      }
      
      
      var selectedSortOption = document.querySelector("#SortBy").value;
      if (selectedSortOption === "price-ascending") {
        window.sortListByPrice("ascending");
      } else if (selectedSortOption === "price-descending") {
        window.sortListByPrice("descending");
      }
  
  
  
      document.querySelectorAll(`[data-span-filter-color]`).forEach(el => {
        if(document.querySelectorAll(`[data-filter-color-` + el.getAttribute("data-filter-color") + `]`).length > 0){
            var totalVarients = 0;
            totalVarients = (document.querySelectorAll(`[data-filter-color-` + el.getAttribute("data-filter-color") + `]`).length - document.querySelectorAll("li.grid__item.visually-hidden[data-filter-color-" + el.getAttribute("data-filter-color") + "]").length);
            el.parentNode.querySelector(`span[` + el.getAttribute("data-filter-color") + `]`).innerHTML =  totalVarients < 0 ? 0 : totalVarients ;
            el.parentNode.querySelector(`span[` + el.getAttribute("data-filter-color") + `]`).closest("li").classList.remove("visually-hidden");
        }
        else{
            el.parentNode.querySelector(`span[` + el.getAttribute("data-filter-color") + `]`).innerHTML = 0;
            el.parentNode.querySelector(`span[` + el.getAttribute("data-filter-color") + `]`).closest("li").classList.add("visually-hidden");
        }
      });
  
      document.querySelectorAll(".list-menu__item.facets__item").forEach(el => {
        if(el.querySelector("input").hasAttribute("disabled")){
            el.classList.add("visually-hidden");
        }
      });
  
       document.querySelectorAll("[data-span-filter-common]").forEach(el => {
          if(parseInt(el.parentNode.querySelectorAll("span")[1].innerHTML) == 0){
              el.closest("li").classList.add("visually-hidden");
          }
         else{
           el.closest("li").classList.remove("visually-hidden");
         }
      });

      document.querySelector(".mobile-facets__count").innerHTML = document.querySelectorAll("#product-grid li").length + " products";
      
      var selectedSortOption = document.querySelector("#SortBy").value;
      if (selectedSortOption === "price-ascending") {
        window.sortListByPrice("ascending");
      } else if (selectedSortOption === "price-descending") {
        window.sortListByPrice("descending");
      }
      
      document.querySelector(".facets-container .full-page-loader").classList.remove("loading");
      document.querySelector(".facets-container .full-page-loader").classList.add("visually-hidden");
      document.querySelector(".facets-container .full-page-loader").innerHTML = "";

      if(document.querySelectorAll("#ProductGridContainer .collection-loader").length > 0){
        document.querySelector("#ProductGridContainer .collection-loader").classList.remove("loading");
        document.querySelector("#ProductGridContainer .collection-loader").classList.add("visually-hidden");
        document.querySelector("#ProductGridContainer .collection-loader").innerHTML = "";
      }
      window.pageNumber = 2;


      if(!window.showPagination){
        // Create an intersection observer
        const observer = new IntersectionObserver(window.executeOnceInViewport, { threshold: 0 });
        
        // Observe the paginationWrapper element
        var paginationWrapper = document.querySelector(".pagination-wrapper");
        if (paginationWrapper) {
          observer.observe(paginationWrapper);
        }
      }
      
    }, 0);
  }

if(window.currentTemplate == "variantsasaproduct"){
  window.customFilterFunctions();
}
/* Filter Custom Development - End  */


// Match height js
var matchHeight = function(selector) {
  var elements = document.querySelectorAll(selector);
  var maxHeight = 0;
  for (var i = 0; i < elements.length; i++) {
    elements[i].style.height = 'auto';
    if (elements[i].offsetHeight > maxHeight) {
      maxHeight = elements[i].offsetHeight;
    }
  }
  for (var i = 0; i < elements.length; i++) {
    elements[i].style.height = maxHeight + 'px';
  }
};

window.onload = function() {
  matchHeight('.products-list-item .products-list-img');
  matchHeight('.products-list-item .products-list-content .product-title');
};

window.onresize = function() {
  matchHeight('.products-list-item .products-list-img');
  matchHeight('.products-list-item .products-list-content .product-title');
};

matchHeight('.products-list-item .products-list-img');
matchHeight('.products-list-item .products-list-content .product-title');


document.addEventListener("DOMContentLoaded", function () {
  var paginationWrapper = document.querySelector(".pagination-wrapper");
  var isFunctionExecuted = false; // Flag to track function execution

  window.executeOnceInViewport = async function(entries, observer) {
    var paginationWrapper = document.querySelector(".pagination-wrapper");
    if(document.querySelector("div.pagination-wrapper") != null){
      if(typeof parseInt(document.querySelector("div.pagination-wrapper").getAttribute("pagination-total-pages")) !== "undefined"){
        let totalPageCount1 = parseInt(document.querySelector("div.pagination-wrapper").getAttribute("pagination-total-pages"));
        if(window.pageNumber <= totalPageCount1){
          if (entries[0].isIntersecting && !isFunctionExecuted) {
            console.log("is in viewport");
            
            document.querySelector(".pagination.full-page-loader").classList.add("loading");
            document.querySelector(".pagination.full-page-loader").classList.remove("visually-hidden");
            document.querySelector(".pagination.full-page-loader").innerHTML = ".";
            
            isFunctionExecuted = true;
            var totalPages1 = parseInt(document.querySelector("div.pagination-wrapper").getAttribute("pagination-total-pages"));
            var newUrl1 = removeParamFromUrl(window.location.href, "page");
            var paginatedUrl1 = newUrl1; 

            console.log(paginatedUrl1);

            if(paginatedUrl1.includes("?")){
              paginatedUrl1 = paginatedUrl1 + "&page=" + window.pageNumber;
            }
            else{
              paginatedUrl1 = paginatedUrl1 + "?page=" + window.pageNumber;
            }

            console.log(paginatedUrl1);
            
            const response1 = await fetch(paginatedUrl1);
            let responseData1 = await response1.text();
            let htmlData1 = stringToHTML(responseData1);
            htmlData1.forEach(el => {
              document.querySelector('#product-grid').append(el);
            });
            window.pageNumber = window.pageNumber + 1;
            $('.klaviyo-product-container').each(function(){
            var current_product_handle = $(this).attr('data-klaviyo-handle');
            var notify_btn_html = `<div class="klaviyo-button-container" style="display: inline-block; top: 50%; left: 50%; text-align: center; width: 200px; margin-left: -100px; opacity: 0; position: absolute !important;"><a class="button button-bis klaviyo-bis-trigger" href="#" style="padding: inherit; text-align: center;" data-klaviyo-handle="${current_product_handle}">Notify Me When Available</a></div>`;
            $(this).append(notify_btn_html);
            })
            var selectedSortOption = document.querySelector("#SortBy").value;
            if (selectedSortOption === "price-ascending") {
              window.sortListByPrice("ascending");
            } else if (selectedSortOption === "price-descending") {
              window.sortListByPrice("descending");
            }
                  
            document.querySelector(".pagination.full-page-loader").classList.remove("loading");
            document.querySelector(".pagination.full-page-loader").classList.add("visually-hidden");
            document.querySelector(".pagination.full-page-loader").innerHTML = "";
            
          } 
          else if (!entries[0].isIntersecting) {
            isFunctionExecuted = false; // Reset the flag when the element is out of the viewport
          }
        }
      }
    }
  }

  if(!window.showPagination){
    // Create an intersection observer
    const observer = new IntersectionObserver(window.executeOnceInViewport, { threshold: 0 });
  
    // Observe the paginationWrapper element
    if (paginationWrapper) {
      observer.observe(paginationWrapper);
    }
  }
});

/* Infinite Scrolling on collection Page -- End */

document.addEventListener("DOMContentLoaded", function () {

  /* function to change the image of the color variant -- Start */
  function setVariantBackgroundImages() {
    const variantsElem = document.querySelectorAll("variant-radios fieldset");
    const optionsArray = [];
    const options = document.querySelectorAll("select.staticvariantimage option");
    
    if (variantsElem.length > 0) {
      variantsElem[0].querySelectorAll("label").forEach((el, index) => {
        const prodOptions = Array.from(document.querySelectorAll("variant-radios fieldset"))
          .slice(1)
          .map(fieldset => fieldset.querySelector("label").getAttribute("swatch_image"))
          .join(" / ");
    
        optionsArray[index] = prodOptions ? `${el.getAttribute("swatch_image")} / ${prodOptions}` : el.getAttribute("swatch_image");

        options.forEach(option => {
          if(optionsArray[index] != null){
            if (option.value.trim() === optionsArray[index].trim()) {
              el.style.backgroundImage = `url(${option.getAttribute("data-img")})`;
              el.setAttribute("data-oos",option.getAttribute("data-avail"));
            }
          }
        });
      });
    }
  }
  
  setVariantBackgroundImages();
  /* function to change the image of the color variant -- End */



  var monogramEventSelectors = {
    _monogramVariants: document.querySelectorAll(".monogram__addon-variant"),
    _monogramImages: document.querySelectorAll(".monogram__images img"),
    _monogramImg: document.querySelector(".monogram__images"),
    _btnMonogramAtc: document.querySelector(".button_monogram-product-atc"),
    _allCharOption: document.querySelectorAll(".allNumberOptions"),
    _imageUrlPosArr: [],
  }
  
  window.monogramAddOn = {
    _init: function() {
      this._eventBinder();
      // this._listVariantImages();
      this._showImageUls();
    },
    _showImageUls: function(){
      monogramEventSelectors._allCharOption.forEach(elme => {
        document.querySelector(".allNumberOptions:checked").value
        document.querySelectorAll(".monogram__product.container ul").forEach((elem, index) => {
          if((parseInt(document.querySelector(".allNumberOptions:checked").value) - 1) < index){
            elem.classList.add("hidden");
            (typeof document.querySelectorAll(".monogram__images img")[index] !== "undefined") ? document.querySelectorAll(".monogram__images img")[index].classList.add("hidden") : "";
          }
          else{
            elem.classList.remove("hidden");
            (typeof document.querySelectorAll(".monogram__images img")[index] !== "undefined") ? document.querySelectorAll(".monogram__images img")[index].classList.remove("hidden") : "";
          }
        })
      });
    },
    _eventBinder: function(){
      monogramEventSelectors._monogramVariants.forEach(li => {
        li.addEventListener("click", this._listVariantImages.bind(this), true);
        const childElements = li.querySelectorAll(".monogram__addon-variant");
        childElements.forEach(child => {
          li.addEventListener("click", this._addEventToEachChileElement.bind(this), true);
        });
      });
      if(monogramEventSelectors._btnMonogramAtc != null){
        monogramEventSelectors._btnMonogramAtc.addEventListener("click", this._getVariantsDetails.bind(this), true);
      }
    },
    _listVariantImages: function(e){
      const clickedLi = e.currentTarget;
      const ulElement = e.target.closest("ul");
      if (ulElement) {
        ulElement.querySelectorAll(".monogram__addon-variant").forEach(ele => {
          ele.classList.remove("active");
        });
        clickedLi.classList.toggle("active");
        this._addImageAboveFeaturedImage(clickedLi.dataset.image_src, (parseInt(clickedLi.parentNode.dataset.ul_number)) );
      }
      window.monogramAddOn._showImageUls();
    },
    _addEventToEachChileElement: function(){
      child.addEventListener("click", function(e) {
        e.stopPropagation();
      });
    },
    _addImageAboveFeaturedImage: function(imageUrl, position) {
      const imgElement = document.createElement("img");
      monogramEventSelectors._imageUrlPosArr[position] = imageUrl;
      monogramEventSelectors._monogramImg.innerHTML = "";
      for (let i = 1; i <= 3; i++) {
        const imgPosition = i;
        const imgSrc = monogramEventSelectors._imageUrlPosArr[i];
        if(typeof monogramEventSelectors._imageUrlPosArr[i] !== "undefined"){
          const imgElement = document.createElement("img");
          imgElement.setAttribute("src", imgSrc);
          imgElement.setAttribute("data-image_position", i);
          monogramEventSelectors._monogramImg.appendChild(imgElement);
        }
      }
    },
    _getVariantsDetails: function(event){

      // if(event.target.getAttribute("data-monogram_product_id"))
      console.log(event.currentTarget.getAttribute("data-monogram_product_id"));
      
      var arrVariantIds = [];

      let SelectedVariants = document.querySelectorAll(".monogram__addon-variant.active");

      SelectedVariants.forEach(el => {
        console.log(el.dataset.monogram_variant_id);

        if(!el.closest("ul").classList.contains("hidden")){
          var variantId = parseInt(el.dataset.monogram_variant_id);

          if(typeof arrVariantIds[variantId] !== "undefined"){
            arrVariantIds[variantId] = {
              "varId": variantId,
              "quantity": arrVariantIds[variantId].quantity + 1,
              "properties": {
                ...(event.currentTarget.getAttribute("data-monogram_product_id") ? { "_FinalSale": variantId} : {})
              }
            };
          }
          else{
            arrVariantIds[variantId] = {
              "varId": variantId,
              "quantity": 1,
              "properties": {
                ...(event.currentTarget.getAttribute("data-monogram_product_id") ? { "_FinalSale": variantId} : {})
              }
            };
          }

          console.log(arrVariantIds);
          
        }
      })

      let currProdVarId = parseInt(document.querySelector(".button_monogram-product-atc").closest("form").querySelector("[name='id']").value);
      arrVariantIds[currProdVarId] = {
        "varId": currProdVarId,
        "quantity": 1,
         "properties": {
          }
      }

      this._generateJsonString(arrVariantIds);
    },
    _generateJsonString: function(arrVariantIds){
      let formDatamonoGram = {};
      formDatamonoGram['items'] = [];
      for (var variantId in arrVariantIds) {
        var entry = {
          'id': arrVariantIds[variantId].varId,
          'quantity': arrVariantIds[variantId].quantity,
          'properties': arrVariantIds[variantId].properties
        };
        formDatamonoGram['items'].push(entry);
      }
      
      formDatamonoGram['sections'] = window.CartDrawerItems.getSectionsToRender().map((section) => section.section);
      formDatamonoGram['sections_url'] = window.location.pathname;
        
      this._addProductToCart(formDatamonoGram);
    },
    _addProductToCart: function(jsonFormData){
      let cart = document.querySelector("cart-notification") || document.querySelector("cart-drawer");
      return fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(jsonFormData)
      })
      .then(response => {
        return response.json();
      })
      .then(response => {
        this.cart = document.querySelector("cart-notification") || document.querySelector("cart-drawer");    
        const cartRef = this.cart; // Store the reference to the cart object
        for (let resp in response.items) {
          response.items[resp]['sections'] = response.sections;
          cartRef.renderContents(response.items[resp]); // Use the stored reference here
        }
        if (cartRef && cartRef.classList.contains("is-empty"))
        cartRef.classList.remove("is-empty");
      })
      .catch((error) => {
        console.error('Error:', error);
      });
    }
  }

  window.monogramAddOn._init();

  window.removeQueryParam = function(paramsString, paramToRemove, valueToRemove) {
    const searchParams = new URLSearchParams(paramsString);
  
    const paramValues = searchParams.getAll(paramToRemove);
    const updatedValues = paramValues.filter(value => value !== valueToRemove);
  
    if (updatedValues.length === 0) {
      searchParams.delete(paramToRemove);
    } else {
      searchParams.set(paramToRemove, updatedValues);
    }
  
    return searchParams.toString();


  };
  
  // const queryParams = "sort_by=manual&filter.v.availability=1&filter.v.availability=1&filter.v.price.gte=122.00&filter.v.price.lte=160.90&filter.p.product_type=Diaper+Bags&filter.p.product_type=Diaper+Bags&filter.v.m.itzyritzy.collection";
  // const paramToRemove = "filter.p.product_type";
  // const valueToRemove = "Diaper Bags";
  
  // const updatedQueryParams = window.removeQueryParam(queryParams, paramToRemove, valueToRemove);
  // console.log(updatedQueryParams);

  function removeExtraButtons() {
      var buttonContainers = document.querySelectorAll('.klaviyo-button-container');
      buttonContainers.forEach(function(container) {
          var buttons = container.querySelectorAll('.klaviyo-bis-trigger');
          if (buttons.length > 1) {
              for (var i = 1; i < buttons.length; i++) {
                  buttons[i].parentNode.removeChild(buttons[i]);
              }
          }
      });
  }
  removeExtraButtons();
});

/* Infinite Scrolling on collection Page -- End */



function featurePostSlider () {

  $('.featured-posts__items').not('.slick-initialized').slick({
      dots: true,
      arrows: true,
      centerMode: true,
      centerPadding: '0',
      slidesToShow: 3,
      variableWidth: true,
      autoplay: true,
      autoplaySpeed: 3000,
      mobileFirst: true,
      responsive: [
          {
              breakpoint: 768,
              settings: {
                  centerMode: false,
                  centerPadding: '0',
                  slidesToShow: 3,
                  autoplay: true,
              }
          }
      ]
  });
}

function inspoSlider() {
  $('.inspo-to-read__items').not('.slick-initialized').slick({
      centerMode: false,
      variableWidth: false,
      arrows: false,
      fade: true,
      slidesToShow: 1,
      responsive: [
      {
        breakpoint: 990,
        settings: {
          fade: false,
          arrows: true,
          slidesToShow: 3,
          slidesToScroll: 1,
          mobileFirst: true,
          centerMode: true,
          variableWidth: true,
        }
      }
    ]
  });

}

$(document).ready(function () {
  featurePostSlider();
  inspoSlider();

  $(".sidenav__title").on('click', function() {
    const $parent = $('.sidenav');
    $parent.toggleClass('sidenav--open');
  });
  
  $(".sidenav__list-item").on('click', function() {
    $('.sidenav').removeClass('sidenav--open');
  });
  
});

$(window).resize(function(){
  inspoSlider();
  if($('.inspo-to-read__items').length > 0) {
    $('.inspo-to-read__items')[0].slick.refresh();    
  }

  // featurePostSlider();
});


document.addEventListener('rebuy:smartcart.hide', (event) => {
  document.body.classList.remove("overflow-hidden");
});

document.addEventListener('DOMContentLoaded', function () {
  var readmoreButtons = document.querySelectorAll('.readmore');
  var readlessButtons = document.querySelectorAll('.readless');

  readmoreButtons.forEach(function (button) {
    button.addEventListener('click', function (event) {
      event.preventDefault();
      var descriptionFull = document.querySelector('.product-description-full');
      var descriptionShort = document.querySelector('.product-description-short');
      descriptionFull.style.display = 'block';
      descriptionShort.style.display = 'none';
    });
  });

  readlessButtons.forEach(function (button) {
    button.addEventListener('click', function (event) {
      event.preventDefault();
      var descriptionFull = document.querySelector('.product-description-full');
      var descriptionShort = document.querySelector('.product-description-short');
      descriptionFull.style.display = 'none';
      descriptionShort.style.display = 'block';
    });
  });
});



// Custom payment info icon popup product page

document.addEventListener('DOMContentLoaded', (event) => {
    var openPopupBtn = document.querySelector('.custom_payment');
    var popup = document.querySelector('#custom_payment_popup');
    var closePopupBtn = document.querySelector('.custom_payment-close-button');
    var gotItBtn = document.getElementById('got-it-btn');

    openPopupBtn.onclick = function() {
        popup.classList.add('show');
    }

    closePopupBtn.onclick = function() {
        popup.classList.remove('show');
    }

    gotItBtn.onclick = function() {
        popup.classList.remove('show');
    }

    window.onclick = function(event) {
        if (event.target == popup) {
            popup.classList.remove('show');
        }
    }
});

// set custom validity for footer newsletter form
document.getElementById('NewsletterForm--newsletter').addEventListener('input', function(event) {
  const textarea = event.target;
  const currentValue = textarea.value;
  const forbiddenCharacters = /[\\\/\'\"\-\>\<\&]/g;
  const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  const sanitizedValue = currentValue.replace(forbiddenCharacters, '');
  textarea.value = sanitizedValue;

  if (currentValue !== sanitizedValue) {
    textarea.setCustomValidity('Special characters \\ / \' " - > < & are not allowed.');
  } else if (!emailPattern.test(currentValue) && currentValue !== '') {
    textarea.setCustomValidity('This email is invalid');
  } else if(currentValue == ''){
    textarea.setCustomValidity('This field is required.');
  }else{
    textarea.setCustomValidity("")
  }
  textarea.reportValidity();
});

document.querySelector('.newsletter-form__button').addEventListener('click', function(e) {    
  const emailInput = document.getElementById('NewsletterForm--newsletter');
  const emailValue = emailInput.value.trim();
  const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  if (emailValue === '') {
    emailInput.setCustomValidity('This field is required.');
    e.preventDefault(); 
  } else if (!emailPattern.test(emailValue)) {
    emailInput.setCustomValidity('This email is invalid');
    e.preventDefault(); 
  } else {
    emailInput.setCustomValidity('');
  }
  emailInput.reportValidity();
});